<template>
  <login-form
    title="Confirm SMS Code"
    go-action="Submit"
    @submit="login"
    :loading="loading"
    logo="/logo.png"
    :errors="errors"
  >
    <password-input v-model="password" label="Code" autofocus />
  </login-form>
</template>

<script>
import LoginForm from '@/components/Form'
import { mapGetters } from 'vuex'
import { STATE_CHALLENGE, STATE_USER_ID } from '@/store'
import PasswordInput from '@/components/PasswordInput'
import mixinHandleError from '@/mixins/handle-error'

export const ROUTE_NAME = 'UserCode'

export default {
  name: ROUTE_NAME,
  mixins: [mixinHandleError],
  components: {
    LoginForm,
    PasswordInput
  },
  computed: {
    ...mapGetters({
      challenge: STATE_CHALLENGE,
      userID: STATE_USER_ID
    })
  },
  data: () => ({
    password: '',
    loading: false
  }),
  methods: {
    async login () {
      this.loading = true
      this.clearErrors()
      try {
        const resp = await this.axios.post('/api/v1/login/code', {
          challenge: this.challenge,
          uid: '' + this.userID,
          password: this.password
        })

        if (resp.headers.location) {
          window.location = resp.headers.location
          return
        }
        throw new Error(
          `no headers on response: ${JSON.stringify(resp, null, 2)}`
        )
      } catch (err) {
        this.storeError(err)
      }
      this.loading = false
    }
  }
}
</script>
